import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { DataGrid } from '@material-ui/data-grid'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { clearErrorAction, adminProductRequestAction, productDeleteAction, productsBulkDeleteAction } from '../redux/actions/productAction'
import swal from 'sweetalert';
import { Button } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import Sidebar from './Sidebar'
import './allProductByAdmin.css'
import { DELETE_PRODUCT_RESET } from '../redux/constants/productConstants'
import Loader from '../layout/loader'
import AddIcon from '@mui/icons-material/Add';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';




function AllProductsByAdmin() {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const initialFilter = searchParams.get('filter') === 'low_stock' ? 'low_stock' : 'all';

    const [searchTerm, setSearchTerm] = useState('');
    const [stockFilter, setStockFilter] = useState(initialFilter);
    const [selectedProductIds, setSelectedProductIds] = useState([]);

    useEffect(() => {
        const queryFilter = searchParams.get('filter');
        if (queryFilter === 'low_stock') {
            setStockFilter('low_stock');
        }
    }, [searchParams]);


    const { loading, error, products } = useSelector((state) => state.products)

    //for delete product by admin

    const { loading: deleteLoading, error: deleteError, isDeleted } = useSelector((state) => state.deleteProduct)


    const deleteProductHandler = (id) => {
        swal({
            title: "Delete product?",
            text: "This product will be removed from the catalogue.",
            icon: "warning",
            buttons: ["Cancel", "Delete"],
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(productDeleteAction(id))
            }
        });
    }

    const bulkDeleteProductsHandler = () => {
        if (!selectedProductIds.length) {
            return swal({
                title: "No products selected",
                text: "Please select products first.",
                icon: "info",
            });
        }

        swal({
            title: `Delete ${selectedProductIds.length} product(s)?`,
            text: "Selected products will be permanently removed from the catalogue.",
            icon: "warning",
            buttons: ["Cancel", "Delete selected"],
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(productsBulkDeleteAction(selectedProductIds));
            }
        });
    }

    useEffect(() => {
        if (error) {
            swal({
                title: "Validation",
                text: error,
                icon: "error",
            })
            dispatch(clearErrorAction())

        }

        if (deleteError) {
            swal({
                title: "Validation",
                text: deleteError,
                icon: "error",
            })
            dispatch(clearErrorAction())

        }
        if (isDeleted) {
            swal({
                title: "Deleted.",
                text: isDeleted,
                icon: "success",
            })
            setSelectedProductIds([]);
            dispatch({ type: DELETE_PRODUCT_RESET })
        }

        dispatch(adminProductRequestAction())

    }, [deleteError, dispatch, error, history, isDeleted])





    const columns = [
        // { field: '', headerName: 'Select', type:'checkbox', minWidth: 200, flex: 0.5 },
        { field: 'id', headerName: 'Product ID', minWidth: 200, flex: 0.5 },
        {
            field: 'name',
            headerName: 'Name',
            minWidth: 300,
            flex: 1,
        },
        {
            field: 'stock',
            headerName: 'Stock',
            type: 'number',
            minWidth: 150,
            flex: 0.3,
        },
        {
            field: 'price',
            headerName: 'Price',
            type: 'number',
            minWidth: 250,
            flex: 0.5,
        },
        {
            field: 'action',
            headerName: 'Action',
            type: 'number',
            minWidth: 150,
            flex: 0.3,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Fragment>
                        <Link to={`/Admin/dashboard/UpdateProduct/${params.getValue(params.id, 'id')}`}   >
                            <EditIcon />
                        </Link>

                        <Button onClick={() => deleteProductHandler(params.getValue(params.id, 'id'))}   >
                            <DeleteIcon />
                        </Button>

                        {/* <Button onClick={() => productSelectedHandler(params.getValue(params.id, 'id'))}   >   */}
                        {/* <button  >
                        <input type='checkbox' multiple={true} value={params.getValue(params.id, 'id')}  onChange={(e)=>setIsChecked(e.target.value)} />

                        </button> */}
              

                        {/* <DeleteIcon /> */}
                        {/* nClick={() => deleteProductHandler(params.getValue(params.id, 'id')) */}
                    </Fragment>
                )
            }
        },
    ]

    const rows = useMemo(() => {
        let productRows = [];
        products && products.forEach(item => {
            productRows.push({
                id: item._id,
                stock: item.productStock,
                price: item.price,
                name: item.name,
            });
        });

        if (stockFilter === 'low_stock') {
            productRows = productRows.filter((item) => Number(item.stock || 0) <= 5);
        } else if (stockFilter === 'out_of_stock') {
            productRows = productRows.filter((item) => Number(item.stock || 0) <= 0);
        }

        const normalizedSearch = searchTerm.trim().toLowerCase();
        if (!normalizedSearch) return productRows;

        return productRows.filter((item) =>
            item.id.toLowerCase().includes(normalizedSearch) ||
            item.name.toLowerCase().includes(normalizedSearch)
        );
    }, [products, searchTerm, stockFilter]);

    const totalProducts = products ? products.length : 0;
    const lowStockProducts = products ? products.filter((item) => Number(item.productStock || 0) <= 5).length : 0;
    const totalStock = products ? products.reduce((sum, item) => sum + Number(item.productStock || 0), 0) : 0;


    return (
        <Fragment>
            {loading ? <Loader /> : (<Fragment>
                {deleteLoading ? <Loader /> : (<Fragment>
                    <div className="dashboard-container">
                        <Sidebar />
                        <div className="productListContainer">
                            <div className='admin-list-hero'>
                                <div>
                                    <h1>All products</h1>
                                    <p>Search, edit, and monitor catalogue stock from one place.</p>
                                </div>
                                <div className='admin-list-actions'>
                                    <button
                                        type='button'
                                        className='admin-list-danger-button'
                                        disabled={!selectedProductIds.length || deleteLoading}
                                        onClick={bulkDeleteProductsHandler}
                                    >
                                        <DeleteSweepIcon />
                                        Delete selected
                                    </button>
                                    <Link to='/Admin/dashboard/Create/Product' className='admin-list-action-button'>
                                        <AddIcon />
                                        Add product
                                    </Link>
                                </div>
                            </div>

                            {stockFilter !== 'all' && (
                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', padding: '8px 16px', background: '#fef3c7', border: '1.5px solid #fde68a', borderRadius: '10px', marginBottom: '14px', fontSize: '13px', color: '#92400e', fontWeight: 700 }}>
                                    <span>Showing only <strong>{stockFilter === 'low_stock' ? 'Low Stock (<=5)' : 'Out of Stock'}</strong> products ({rows.length})</span>
                                    <button
                                        type='button'
                                        onClick={() => setStockFilter('all')}
                                        style={{ background: '#ffffff', border: '1px solid #d97706', color: '#b45309', borderRadius: '6px', padding: '3px 10px', fontSize: '12px', fontWeight: 800, cursor: 'pointer' }}
                                    >
                                        ✕ Clear Filter (Show All)
                                    </button>
                                </div>
                            )}

                            <div className='admin-list-toolbar'>
                                <input
                                    className='admin-list-search'
                                    type='search'
                                    placeholder='Search by product name or ID'
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <select
                                    value={stockFilter}
                                    onChange={(e) => setStockFilter(e.target.value)}
                                    style={{ padding: '8px 12px', borderRadius: '8px', border: '1.5px solid #cbd5e1', fontSize: '13px', fontWeight: 700, color: '#334155' }}
                                >
                                    <option value='all'>All Stock Levels</option>
                                    <option value='low_stock'>⚠️ Low Stock (&lt;=5)</option>
                                    <option value='out_of_stock'>Out of Stock (0)</option>
                                </select>
                                <div className='admin-list-stat'>
                                    <span>Total</span>
                                    <strong>{totalProducts}</strong>
                                </div>
                                <div className='admin-list-stat'>
                                    <span>Low stock</span>
                                    <strong>{lowStockProducts}</strong>
                                </div>
                                <div className='admin-list-stat'>
                                    <span>Units</span>
                                    <strong>{totalStock}</strong>
                                </div>
                                <div className='admin-list-stat admin-list-selected-stat'>
                                    <span>Selected</span>
                                    <strong>{selectedProductIds.length}</strong>
                                </div>
                                {selectedProductIds.length > 0 && (
                                    <button
                                        type='button'
                                        className='admin-list-clear-selection'
                                        onClick={() => setSelectedProductIds([])}
                                    >
                                        Clear selection
                                    </button>
                                )}
                            </div>
                            <DataGrid

                                rows={rows}
                                columns={columns}
                                pageSize={20}
                                checkboxSelection
                                selectionModel={selectedProductIds}
                                onSelectionModelChange={(newSelection) => {
                                    setSelectedProductIds(newSelection.map((id) => String(id)));
                                }}
                                disableSelectionOnClick
                                className='productListTable'
                                autoHeight
                            />
                        </div>
                    </div>
                </Fragment>)}
            </Fragment>)}
        </Fragment>
    )
}

export default AllProductsByAdmin
